<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
      <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid" id="table-to-print" >
  <div class="card shadow">
    <div class="card-header">
        <div class="d-flex justify-content-between">
          <h4 class="font-weight-bold text-dark py"> Kalaignar100 District-wise Winners list </h4>
          <!-- <div style="width:220px" *ngIf="user_category !='DA'">
            <label>District / மாவட்டம்</label>
            <select class="form-control" (change)="DistrictChange($event)">
              <option value="" disabled selected hidden>Select District</option>
              <option *ngFor="let option of district_list" (value)="option">
                  {{option}}</option>
            </select>
          </div> -->
        </div>
    </div>
    <div class="wrapper" >
      <div >
        <div class="form-group row">
          <div class="col-sm-6 mb-3 mb-sm-0">
            <label>Party District / கட்சி மாவட்டம்<span class="required "> *</span></label><br>
             <select class="form-control"  [(ngModel)]="district" (change)="Constituency_selection(district)">
              <option value="" selected disabled hidden>Select District</option>
              <option *ngFor="let option of district_list" (value)="option" >
                {{option}}</option>
            </select> 
            <div class="invalid-msg" *ngIf="!district" [hidden]='hidden'>Select District
            </div>
            <!-- <div  class="invalid-msg" *ngIf="district =='Select District' && officebearerform.status=='VALID'" >
              Select District </div> -->
          </div>
          
          <div class="col-sm-6">
            <label>Assembly constituency / சட்டமன்ற தொகுதி<span class="required "> *</span></label><br>
              <!-- <input type="text" name="constituency" [value]="show_constituency" class="form-control"
              placeholder="Party District / கட்சி மாவட்டம்" readonly="readonly" />  -->
              <select class="form-control" [(ngModel)]="constituency" (change)="winner_report_api(constituency)">
                <option value="" selected disabled hidden >Select constituency</option>
                <option *ngFor="let option of user_constituency" [value]="option">{{option}}</option>
              </select>
          </div>
        </div>
       </div>
       <div class="card-body" *ngIf="!show_data">
          <div class="form-group row">
            <div class="col-sm-6 mb-3 mb-sm-0">
              <label>No of Participants / பங்கேற்பாளர்களின் எண்ணிக்கை<span class="required">*</span></label>
              <input type="text" name="no_of_participants" class="form-control" [value]="show_no_of_participants"
                placeholder="No of Participants / பங்கேற்பாளர்களின் எண்ணிக்கை" readonly="readonly" />

              <!-- Display validation error message if the field is touched and invalid -->
              

            </div>

            <div class="col-sm-6 mb-3 mb-sm-0">
              <label>Date of Competition / போட்டி தேதி<span class="required">*</span></label>
              <input type="date" name="date_of_compertition" class="form-control"
               [value]="show_comp_date" readonly="readonly" />
              
            </div>

          </div>

          <div class="form-group row">
            <label>Venue of the Competition / போட்டி நடைபெற்ற இடம்<span class="required">*</span></label>
            <textarea name="venue" class="form-control" placeholder="Venue of the Competition / போட்டி நடைபெற்ற இடம்"
               [value]="show_venue" readonly="readonly"></textarea>
            
          </div>
          <div class="form-group row">
            <div class="col-sm-4 mb-3 mb-sm-0">
              <label>Photo 1<span class="required "> *</span></label>
              <!-- <input type="file" name="images1" class="form-control" accept="image/*"
               > -->
            
            <img [src]="imageSrc1" *ngIf="imageSrc1" style="height: 190px; width:160px; border: 1px solid #555; ">
          </div>  

            <div class="col-sm-4 mb-3 mb-sm-0">
              <label>Photo 2<span class="required "> *</span></label>
              <!-- <input type="file" name="images2" class="form-control" accept="image/*"
              > -->
             
           


            <img [src]="imageSrc2" *ngIf="imageSrc2" style="height: 190px; width:160px; border: 1px solid #555; ">
          </div>
          
      
            <div class="col-sm-4 mb-3 mb-sm-0">
              <label>Photo 3<span class="required "> *</span></label>
              <!-- <input type="file" name="images3" class="form-control" accept="image/*"
               > -->
             
      


            <img [src]="imageSrc3" *ngIf="imageSrc3" style="height: 190px; width:160px; border: 1px solid #555; ">

          </div>
        </div>
          <div class="form-group row">
            <div class="col-sm-4 mb-3 mb-sm-0">
              <label>Photo 4<span class="required "> *</span></label>
              <!-- <input type="file" name="images4" class="form-control" accept="image/*"
               > -->
              
           


            <img [src]="imageSrc4" *ngIf="imageSrc4" style="height: 190px; width:160px; border: 1px solid #555; ">
          </div>
         
            <div class="col-sm-4 mb-3 mb-sm-0">
              <label>Photo 5<span class="required "> *</span></label>
              <!-- <input type="file" name="images5" class="form-control" accept="image/*"
               > -->
       


            <img [src]="imageSrc5" *ngIf="imageSrc5" style="height: 190px; width:160px; border: 1px solid #555; ">
     
          </div>
          </div>

          <div class="table-responsive">
            <table class="table table-bordered table-hover" id="tab_logic">
              <thead>
                <tr>
                  <th class="text-center" colspan="8">Winners Details</th>
                </tr>
                <tr>
                  <th class="text-center">S.No</th>
                  <th class="text-center">Positions</th>
                  <th class="text-center">Register No</th>
                  <th class="text-center">Name</th>
                  <th class="text-center">College Name</th>
                  <th class="text-center">Phone No</th>
                  <th class="text-center">Topics</th>
                  <th class="text-center">Photo</th>
                
                </tr>
              </thead>
              <tbody id="table-body">
                <tr *ngFor="let winner of winnersArray; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ winner.position }}</td>
                  <td>{{ winner.register_number }}</td>
                  <td>{{ winner.student_name }}</td>
                  <td>{{ winner.college_name }}</td>
                  <td>{{ winner.mobile_number }}</td>
                  <td>{{ winner.topic }}</td>
                  
                  <td>  <img [src]="sanitizeWinnerImage(winner.image)" alt="Winner Image" style="width: 100px; height: 100px;"></td>
                
                  <!-- let objectURL1 =
                  'data:image/jpeg;base64,' + images[1].image;
                  this.imageSrc1 = this.sanitizer.bypassSecurityTrustUrl(objectURL1);
                  <td>{{ winner.image }}</td> -->
                  <!-- Add more columns for other properties as needed -->
                </tr>
              </tbody>
            </table>
          </div>
          
          <div class="d-flex justify-content-center">
            <div style="width: 200px">
                <button class="btn btn-primary print-button" (click)="printPage()">Print</button>
            </div>
       
         

      </div>
    </div>
  </div>
  </div>
  <div class="text-secondary text-center" *ngIf="show_data"><h3><b>No Data Found </b></h3></div>
  <!-- <div> No Data Found</div> -->
</div>